// extracted by mini-css-extract-plugin
export var card = "_lg-5";
export var cardSelected = "_lg-4";
export var image = "_lg-3";
export var modal = "_lg-0";
export var modalContent = "_lg-1";
export var table = "_lg-2";